<template>
    <router-link :to="{ name: 'articleDetail_'+dataId }">
        <div class="article-list-item">
            <div class="article-item-wrap">
                <div class="article-item">
                    <div class="left">
                        <img v-bind:src="cover"/>
                    </div>
                    <div class="right">
                        <div class="title">{{title}}</div>
                        <div class="tag-list">
                            <div class="tag" v-for="(tag, index) in tags" :key="index">{{tag}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
    props: {
        dataId: Number,
        cover: String,
        title: String,
        tags: Array
    }
}
</script>

<style lang="scss" scoped>
    .article-list-item {
        .article-item-wrap {
            border-bottom: 1px solid #d8d8d8;
            .article-item {
                display: flex;
                padding: 32px 0px;

                .left {
                    img {
                        width: 283px;
                        height: 207px;
                        margin-right: 63px;
                    }
                }
                .right {
                    .title {
                        max-height: 58px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        font-size: 20px;
                        font-weight: 500;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: normal;
                        letter-spacing: normal;
                        color: #292625;
                        margin-bottom: 20px;
                    }
                    .tag-list {
                        .tag {
                            display: inline-block;
                            font-size: 14px;
                            font-weight: normal;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: normal;
                            letter-spacing: normal;
                            color: #838282;
                            padding: 6px 14px;
                            border-radius: 5px;
                            background-color: #f1f3f6;
                            margin-right: 10px;
                            margin-bottom: 10px;
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1100px){
        .article-list-item {
            .article-item-wrap {
                .article-item {
                    display: block;
                    padding: 24px 20px 25px 20px;

                    .left {
                        img {
                            width: 100%;
                            height: auto;
                            margin-right: unset;
                            margin-bottom: 28px;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/officailPage/article/articleListItem.vue